function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../../styleguide";
import { IconSystemAdd } from "../../Icon";
import Label from "./Label";
import StyledLink from "./StyledLink";

var NewAd = function NewAd(_ref) {
  var pathname = _ref.pathname,
      adInsertUrl = _ref.adInsertUrl,
      onAdInsertClick = _ref.onAdInsertClick;
  var isActive = pathname === '/insert-ad';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  return /*#__PURE__*/React.createElement(StyledLink, {
    href: adInsertUrl,
    onClick: onAdInsertClick,
    onMouseOver: function onMouseOver() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconSystemAdd, {
    width: 20,
    height: 20,
    color: isHovering ? colors.grey800 : colors.grey700
  })), /*#__PURE__*/React.createElement(Label, {
    isActive: isActive,
    isHovering: isHovering
  }, "Ny annons"));
};

NewAd.propTypes = process.env.NODE_ENV !== "production" ? {
  pathname: PropTypes.string,
  onAdInsertClick: PropTypes.func,
  adInsertUrl: PropTypes.string.isRequired
} : {};
export default NewAd;
//# sourceMappingURL=NewAd.js.map